<p>get-company-on-start works!</p>
